import HttpHandler from 'app/reusable/HttpHandler'
import { useEffect, useState } from 'react'

// Resolves a storage path to a signed URL. The result is tied to the path it
// was requested for, so as soon as `url` changes the previous signed URL stops
// being returned: it used to linger until the next response arrived — and,
// when the new path was empty (e.g. the workout player moving on to an
// exercise with no uploaded video), forever, so the previous exercise's video
// kept playing. A slow response for an old path can't overwrite a newer one
// either.
const useSignedUrl = (url) => {
  const isAlreadyResolved = !!url?.startsWith('http')
  const [resolved, setResolved] = useState(null)

  useEffect(() => {
    if (!url || isAlreadyResolved) return undefined

    let cancelled = false
    HttpHandler.getSignedMediaUrl(url).then(
      (res) => {
        if (!cancelled)
          setResolved({ url, signedUrl: res?.data?.signed_url || null })
      },
      (err) => console.warn('Não foi possível assinar a URL da mídia', err)
    )
    return () => {
      cancelled = true
    }
  }, [url, isAlreadyResolved])

  if (isAlreadyResolved) return url
  return url && resolved?.url === url ? resolved.signedUrl : undefined
}

export default useSignedUrl
